import KunLoading31 from './src/index'

KunLoading31.install = function (Vue) {
	Vue.component(KunLoading31.name, KunLoading31);
}

export default KunLoading31;
